export const configAuthToken = (token) => {
    return ("Bearer " + token);
}

export const extractToken = (store) => {
    if(store 
        && store.getState() 
        && store.getState().account 
        && store.getState().account.token){
        return store.getState().account.token;
    }

    return null;
}

export const extractAccount = (response) => {
    return {
        isLoggedIn: true,
        token: response.data.jwtToken,
        user: {
            id: response.data.id,
            username: response.data.username,
            mustChangePassword: response.data.mustChangePassword,
            firstName: response.data.firstName,
            lastName: response.data.lastName,
            roles: response.data.roles
        },
        language: response.data.defaultLanguage,
    };  
}